import { OnboardingStep } from './OnboardingStep';

import type { FlowNextAction } from './flowResolution';
import type { OnboardingFlowResolution } from './useOnboardingFlowResolution';

type StepGuardRules = Pick<
  OnboardingFlowResolution,
  'hasCompletedFlow' | 'hasVerifiedSession' | 'hasVerificationPhone' | 'resumeAction' | 'variant'
>;

export function resolveStepGuard(
  step: OnboardingStep,
  rules: StepGuardRules,
): FlowNextAction | null {
  const isPostVerificationStep =
    step !== OnboardingStep.Landing && step !== OnboardingStep.VerifyPhone;

  if (rules.hasCompletedFlow && step !== OnboardingStep.Success) {
    return { replace: true, type: 'step', step: OnboardingStep.Success };
  }
  if (isPostVerificationStep && !rules.hasVerifiedSession) {
    return { type: 'step', step: OnboardingStep.Landing };
  }
  if (step === OnboardingStep.Success && !rules.hasCompletedFlow) {
    return { type: 'step', step: OnboardingStep.Landing };
  }
  if (step === OnboardingStep.VerifyPhone && !rules.hasVerificationPhone) {
    return { type: 'step', step: OnboardingStep.Landing };
  }
  if (step === OnboardingStep.Landing && rules.hasVerifiedSession && rules.resumeAction) {
    return rules.resumeAction;
  }
  if (isPostVerificationStep && step !== OnboardingStep.Success && rules.resumeAction) {
    if (rules.resumeAction.type === 'step' && rules.resumeAction.step === step) return null;
    return rules.resumeAction;
  }
  if (step === OnboardingStep.ReviewSubscription && rules.variant !== 'individualSub') {
    return { type: 'step', step: OnboardingStep.Landing };
  }
  return null;
}
